import React from "react";
import "./ServicesSection.css";
import ab1 from "../Images/ab1.jpeg";
import ab2 from "../Images/ab2.jpg";
import ab3 from "../Images/ab3.jpg";
import ab4 from "../Images/ab4.jpeg";
import ithero from "../Images/it-hero.jpg";
import slider9 from "../Images/slider-9.jpg"
import slider10 from '../Images/slider-101.jpg';

import { FaServer, FaVolumeUp, FaShieldAlt, FaNetworkWired, FaLeaf } from "react-icons/fa"; // example icons
import { useNavigate } from "react-router-dom";


const services = [
  { title: "Acoustics", link: "/service/acoustics", img: ab3, icon: <FaNetworkWired /> , desc:'Infosight provides comprehensive Building Acoustics services that address environmental noise, internal ambient noise, airborne and impact sound insulation, room acoustic comfort, and mechanical system noise control.'},
  { title: "Security", link: "/service/security", img: ab4, icon: <FaShieldAlt /> ,    desc:"Infosight Consultants provides comprehensive security design solutions focused on safeguarding assets, mitigating risks, and delivering fully integrated protection strategies tailored to each project."},
 
 
   {
    title: "IT / ICT",
    link: "/service/it/ict",
    img: ithero, // it-hero.jpg
    icon: <FaNetworkWired />,
    desc:
      "A fully integrated ICT communication network is essential to modern ELV (Extra Low Voltage) systems, enabling seamless connectivity, efficient operations, and smart automation across building infrastructures.",
  },


   { title: "IBMS", link: "/service/ibms", img: ab2, icon: <FaServer /> ,  desc:"Infosight Consultants will develop preliminary Integrated Building Management System design deliverables strictly within the ELV design scope, focusing only on design inputs and documentation that inform accurate tendering and coordination."},
 
 
  { title: "Audio / Visual (AV) Systems", link: "/service/av", img: ab1, icon: <FaVolumeUp />,  desc:"Infosight Consultants delivers comprehensive Audio Visual (AV) design services that enable seamless communication, collaboration, and media delivery across a wide range of environments." },
 
  {
    title: "Sustainability & Green Building",
    link: "/service/sustainability-&-green-building",
    img: slider9, // slider-9.jpg
    icon: <FaLeaf />,
    desc:
      "By aligning with globally recognized standards such as LEED, BREEAM, Estidama, Mostadam, WELL, Al Sa’fat, IGBC, GRIHA etc., Infosight conducts a Sustainability Assessment and Green Building Rating Strategy in accordance with international best practices.",
  },
];



export default function ServicesSection() {
  const navigate = useNavigate(); // Use the useNavigate hook

  return (
    <section id="services" className="services-section">
      <div className="container">
        {/* <h2 className="section-title" data-aos="fade-up">
          Our Services
        </h2>
        <p className="section-subtitle" data-aos="fade-up" data-aos-delay={100}>
         We assure you that our AV specialist designers hold Infocomm’s CTS certification along with other industry credentials and completed a HEALTHCARE IT, AV, ICT & SECURITY design of a large multi-specialty 500 Bed-Hospital Project in Tirupati, Andhra Pradesh, India.
        </p> */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card"
              data-aos="zoom-in"
              data-aos-delay={index * 150 + 200}
              onClick={() => navigate(service.link)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(service.link);
              }}
              aria-label={`Explore ${service.title} service`}
            >
              <div className="card-image">
                <img src={service.img} alt={service.title} />
              </div>
         <div className="card-overlay">
  <div className="overlay-content">
    <div className="service-icon">{service.icon}</div>
      <p className="desc">{service.desc}</p>
    <h3>{service.title}</h3>
    <p>Explore more →</p>
  </div>
</div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
